import { Typography } from '@mui/material';
import React from 'react';
import PropTypes from 'prop-types';
import { COLORS } from '../../theme';

const defaultProps = {
  fontWeight: 600,
  color: '#222222', // Svart enligt styleguide
  fontFamily: 'Poppins, sans-serif',
  fontSize: '24px',
  sx: {}
};

export const H1 = ({ children, fontWeight, color, fontFamily, fontSize, sx }) => {
  return (
    <Typography 
      variant="h1" 
      sx={{ 
        fontWeight: fontWeight || 600, 
        color: color || '#222222', 
        fontFamily: fontFamily || 'Poppins, sans-serif', 
        fontSize: fontSize || { xs: '20px', md: '24px' },
        marginBottom: '1.5rem', // 24px default spacing
        ...(sx || {}) 
      }}
    >
      {children}
    </Typography>
  );
};

H1.propTypes = {
  fontWeight: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  color: PropTypes.string,
  fontFamily: PropTypes.string,
  fontSize: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
  sx: PropTypes.object
};

H1.defaultProps = defaultProps;

export default H1;
